/// <amd-module name="VSSUI/Registration/VssComponentPicklistRegistration" />
import { VssComponent } from "VSS/Platform/Layout";

import { PickList } from "../PickList";

VssComponent.register("picklist", PickList);
